import { CompanyContext } from 'app/shared/models/company';
import { Route } from '@angular/router';
import {FeatureFlagsService} from "app/shared/services/feature-flags.service";
import { UserInfo } from './user';

export class RouteData {
  name?:
    | string
    | ((
        companyContext: CompanyContext,
        featureFlag: FeatureFlagsService,
        userInfo?: UserInfo,
      ) => string);
  key?: string;
  translateKey?:
    | string
    | ((
        companyContext: CompanyContext,
        featureFlag: FeatureFlagsService,
        userInfo?: UserInfo,
      ) => string);
  menuItem?:
    | boolean
    | ((
        companyContext: CompanyContext,
        featureFlag: FeatureFlagsService,
        userInfo?: UserInfo,
        isLeafNode?: boolean,
        currentGroupId?: number | null,
      ) => boolean);
  adminLink?: boolean;
  permission?: string;
  icon?: string;
  childRoutes?:
    | CustomRoute[]
    | ((
        companyContext: CompanyContext,
        featureFlag: FeatureFlagsService,
        userInfo?: UserInfo,
      ) => CustomRoute[]);
  pendoId?:
    | string
    | ((
        companyContext: CompanyContext,
        featureFlag: FeatureFlagsService,
        userInfo?: UserInfo,
      ) => string);
  readonly?: boolean;
  route?: string;
  breadcrumb?: boolean;
  extraData?: any;
  placeAboveDynamicRoutes?: boolean;
}
export interface CustomRoute extends Route {
  children?: CustomRoute[];
  data?: RouteData;
}


export function getValue<T>(
  property: T | ((companyContext: CompanyContext, featureFlag: FeatureFlagsService, userInfo?: UserInfo, isLeafNode?: boolean, currentGroupId?: number | null) => T),
  companyContext: CompanyContext,
  featureFlag: FeatureFlagsService,
  userInfo?: UserInfo,
  isLeafNode?: boolean,
  currentGroupId?: number | null): T {
  if (property === undefined) return undefined;
  if (typeof property === 'function') {
    return (property as ((companyContext: CompanyContext, featureFlag: FeatureFlagsService, userInfo?: UserInfo, isLeafNode?: boolean, currentGroupId?: number | null) => T))(companyContext, featureFlag, userInfo, isLeafNode, currentGroupId);
  }
  return property;
}
